export enum ERequestFailedReason {
  InternalError = 'internalError',
  SearchUnavailable = 'searchUnavailable',
  Timeout = 'timeout',
}

export interface IRequestFailedPayload {
  requestType: string;
  reason: ERequestFailedReason;
}

export interface IRequestFailedAction {
  type: 'Socket/requestFailed';
  payload: IRequestFailedPayload;
}

export interface IRequestFailedState {
  visible: boolean;
  reason: ERequestFailedReason | null;
}

export interface IRequestTimeoutReportPayload {
  requestType: string;
  timeoutMs: number;
}

export interface IRequestTimeoutReport {
  type: 'Socket/requestTimeoutReport';
  payload: IRequestTimeoutReportPayload;
}
